import { usePiggyUser } from "../../../../utils/piggy/piggy.tsx";
import { useAppSelector } from "../../../../../global/utils/redux/store.tsx";

export type LoyaltyTier = { color?: string; name: string; description: string } | null;

export default function useLoyaltyType(): LoyaltyTier | null {
  const { piggyUser } = usePiggyUser();
  const tiers = useAppSelector((state) => state.global.salesarea.custom_data?.piggy?.tiers);

  if (tiers && piggyUser?.data?.contact?.tierV2) {
    const record = tiers[piggyUser?.data?.contact?.tierV2.uuid];
    return {
      name: piggyUser?.data?.contact?.tierV2.name,
      description: piggyUser?.data?.contact?.tierV2.description,
      color: record && !Array.isArray(record) ? record?.color : undefined,
    };
  }
  return null;
}
